import _ from 'lodash-es';
import toastr from 'toastr';
import sanitize from 'sanitize-html';

toastr.options = {
  timeOut: 3000,
  closeButton: true,
  progressBar: true,
  tapToDismiss: false,
};

export function success(title: string, text: string) {
  toastr.success(sanitize(_.escape(text)), sanitize(title));
}

export function warning(title: string, text: string) {
  toastr.warning(sanitize(_.escape(text)), sanitize(title), { timeOut: 6000 });
}

/** Сообщения, для которых уведомление не показывается. */
const SILENT_MESSAGES = ['Недействительный токен доступа', 'Invalid JWT token'];

export function error(title: string, e?: Error, fallbackText = '') {
  const msg = pickErrorMsg(e) || fallbackText;

  // eslint-disable-next-line no-console
  console.error(e);

  // Истекший или недействительный токен обрабатывается перехватчиком аутентификации:
  // пользователь перенаправляется на экран входа, повторное уведомление не нужно.
  if (!SILENT_MESSAGES.includes(msg)) {
    toastr.error(sanitize(_.escape(msg)), sanitize(title), { timeOut: 6000 });
  }
}

/* @ngInject */
export function Notifications() {
  return {
    success,
    warning,
    error,
  };
}

function pickErrorMsg(e?: Error) {
  if (!e) {
    return '';
  }

  // Порядок важен: локализованное сообщение (`message`) имеет приоритет над
  // техническими подробностями (`details`), которые backend отдаёт на английском
  // языке. `details` используется только тогда, когда сообщения нет.
  const props = [
    'err.data.message',
    'data.message',
    'err.data[0].message',
    'data.content',
    'data.error',
    'err.data.details',
    'data.details',
    'message',
    'err.data.err',
    'data.err',
    'msg',
  ];

  let msg = '';

  props.forEach((prop) => {
    const val = _.get(e, prop);
    if (typeof val === 'string') {
      msg = msg || val;
    }
  });

  return msg;
}
